export default "__VITE_ASSET__DH8uS5W2__";